import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';

import { ProductPartnerNumberSettingsComponent } from './product-partner-number-settings.component';
import { RnplCommonModule } from 'common/src/modules';
import { UIComponentsModule } from 'common/src/modules';

@NgModule({
  declarations: [
    ProductPartnerNumberSettingsComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UIComponentsModule,
    TranslateModule,
    NgSelectModule,
    RnplCommonModule,
  ],
  exports: [
    ProductPartnerNumberSettingsComponent,
  ],
  providers: []
})
export class ProductPartnerNumberSettingsModule { }
